<template>
<div>
    <h1 class="display-heading">Covid-19 Vaccination Booking</h1>

    <div class="bs-stepper">
        <div class="bs-stepper-header" role="tablist">
            <div class="step" data-target="#add-employees">
                <button
                    type="button"
                    class="step-trigger"
                    role="tab"
                    aria-controls="add-employees"
                    id="add-employees-trigger"
                >
                    <span class="bs-stepper-circle">1</span>
                    <span class="bs-stepper-label">Add Employees</span>
                </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#select-location">
                <button
                    type="button"
                    class="step-trigger"
                    role="tab"
                    aria-controls="select-location"
                    id="select-location-trigger"
                >
                    <span class="bs-stepper-circle">2</span>
                    <span class="bs-stepper-label">Select Location</span>
                </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#review">
                <button
                    type="button"
                    class="step-trigger"
                    role="tab"
                    aria-controls="review"
                    id="review-trigger"
                >
                    <span class="bs-stepper-circle">3</span>
                    <span class="bs-stepper-label">Review</span>
                </button>
            </div>
        </div>
        <div class="bs-stepper-content">
            <!-- your steps content here -->
                <div
                    id="add-employees"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="add-employees-trigger"

                >
                    <button @click="$refs.popUpAddEmployee.show()" class="btn btn-primary btn-primary-insv mb-3 float-right">
                        Add Employee
                    </button>
                    <table class="table" style="font-size: 14px;">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <col width="100">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Email</th>
                                <th scope="col">Identity Card Number</th>
                                <th scope="col">Date of Birth</th>
                                <th scope="col">Gender</th>
                                <th scope="col">Nationality</th>
                                <th scope="col">MySejahtera ID</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="employees.length === 0">
                                <td colspan="9" class="text-center font-italic">
                                    {{"No Data"}}
                                </td>
                            </tr>
                            <tr v-for="(employee, index) in employees" :key="index">
                                <td>{{ employee.name }}</td>
                                <td>{{ employee.phone }}</td>
                                <td>{{ employee.email }}</td>
                                <td>{{ employee.identityCardNumber }}</td>
                                <td>{{ convertDateToDDMMYYYY(employee.dob) }}</td>
                                <td>{{ employee.gender === 1 ? 'Male' : 'Female' }}</td>
                                <td>{{ employee.nationality }}</td>
                                <td>{{ employee.mySejahteraId }}</td>
                                <td><button class="btn btn-danger" @click="removeEmployee(index)">Remove</button></td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Next Button -->
                    <button
                        @click="nextStep(1)"
                        class="btn btn-primary btn-primary-insv"
                    >
                        Next
                    </button>
                </div>

                <div
                    id="select-location"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="select-location-trigger"

                >
                    <!-- Location Type select -->
                    <div v-if="employees.length >= 10" class="mb-4">
                        <p><b>Please select the location type.</b></p>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input " type="radio" name="offsite" id="offsite" value="1" v-model="locationType">
                            <label class="form-check-label" for="offsite">
                                <b class="text-danger">Clinic Vaccination</b>
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="onsite" id="onsite" value="2" v-model="locationType">
                            <label class="form-check-label" for="onsite">
                                <b class="text-danger">Onsite Vaccination</b>
                            </label>
                        </div>
                    </div>

                    <!-- Vaccination Centre -->
                    <div v-if="locationType == '1'">
                        <p><b>Please select the region of your office / factory location.</b></p>
                        <p>Note: choose the nearest region, if your region is unavailable.</p>
                        <div class="form-group">
                            <label>Region</label>
                            <select name="region" data-vv-validate-on="blur" data-vv-as="region"
                                v-model="regionId" value="1" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('region')
                            }">
                                <option v-for="(region, index) in regions" :key="index"
                                    :value="region.id">
                                    {{region.name}}
                                </option>
                            </select>

                            <div v-show="validationErrors.has('region')" class="invalid-feedback">
                                {{ validationErrors.first('region') }}
                            </div>
                        </div>
                    </div>

                    <!-- On site -->
                    <div v-else>
                        <p><b>Please enter onsite vaccination details. (Onsite vaccination will incur a RM200 charge for doctor's travel allowance)</b></p>
                        <form data-vv-scope="onsiteForm">
                            <div class="row">
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Person in Charge</label>
                                    <input type="text" name="picName" data-vv-as="person in charge" data-vv-validate-on="blur"
                                        v-model="picName" v-validate="'required'"
                                        placeholder="Person in Charge"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.picName')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.picName')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.picName') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Person in Charge Phone Number</label>
                                    <input type="text" name="picPhone" data-vv-as="person in charge phone number" data-vv-validate-on="blur"
                                        v-model="picPhone" v-validate="'required'"
                                        placeholder="Person in Charge Phone Number"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.picPhone')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.picPhone')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.picPhone') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Prefered Date 1</label>
                                    <input type="text" name="preferedDate1" data-vv-as="prefered date 1" data-vv-validate-on="blur"
                                            v-model="preferedDate1"
                                            v-mask="'##/##/####'"
                                            v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                                            :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.preferedDate1')
                                        }" />
                                    <div v-show="validationErrors.has('onsiteForm.preferedDate1')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.preferedDate1') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Prefered Date 2</label>
                                    <input type="text" name="preferedDate2" data-vv-as="prefered date 2" data-vv-validate-on="blur"
                                            v-model="preferedDate2"
                                            v-mask="'##/##/####'"
                                            v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                                            :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.preferedDate2')
                                        }" />
                                    <div v-show="validationErrors.has('onsiteForm.preferedDate2')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.preferedDate2') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Address 1</label>
                                    <input type="text" name="address1" data-vv-as="address 1" data-vv-validate-on="blur"
                                        v-model="address1" v-validate="'required'"
                                        placeholder="Address 1"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.address1')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.address1')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.address1') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Address 2</label>
                                    <input type="text" name="address2" data-vv-as="address 2" data-vv-validate-on="blur"
                                        v-model="address2" v-validate="'required'"
                                        placeholder="Address 2"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.address2')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.address2')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.address2') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">City</label>
                                    <input type="text" name="city" data-vv-as="city" data-vv-validate-on="blur"
                                        v-model="city" v-validate="'required'"
                                        placeholder="City"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.city')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.city')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.city') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">Postcode</label>
                                    <input type="text" name="postcode" data-vv-as="postcode" data-vv-validate-on="blur"
                                        v-model="postcode" v-validate="'required'"
                                        placeholder="Postcode"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.postcode')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.postcode')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.postcode') }}
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-2">
                                    <label class="mr-2">State</label>
                                    <input type="text" name="state" data-vv-as="state" data-vv-validate-on="blur"
                                        v-model="state" v-validate="'required'"
                                        placeholder="State"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid':  validationErrors.has('onsiteForm.state')
                                        }">
                                    <div v-show="validationErrors.has('onsiteForm.state')" class="invalid-feedback">
                                        {{ validationErrors.first('onsiteForm.state') }}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!-- Back Button -->
                    <button
                        @click="previousStep"
                        class="btn btn-secondary"
                    >
                        Previous
                    </button>

                    <!-- Next Button -->
                    <button
                        @click="nextStep(2)"
                        class="btn btn-primary btn-primary-insv ml-2"
                    >
                        Next
                    </button>
                </div>

                <div
                    id="review"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="review-trigger"
                >
                    <p><b>Please review the below information.</b></p>

                    <!-- Payment info -->
                    <table class="table table-bordered table-sm">
                        <colgroup>
                            <col width="250">
                            <col>
                        </colgroup>
                        <tr>
                            <th colspan="2" class="text-uppercase">Payment info</th>
                        </tr>
                        <tr>
                            <th>Vaccine</th> <!-- Hardcode for now -->
                            <td>Sinovac</td>
                        </tr>
                        <tr>
                            <th>Price</th> <!-- Hardcode for now -->
                            <td>RM {{ vaccinePrice }}</td>
                        </tr>
                        <tr v-if="locationType === '2'">
                            <th>Doctor's travel allowance</th>
                            <td>RM 200</td>
                        </tr>
                        <tr>
                            <th>Total Employees</th>
                            <td>{{ this.employees.length }}</td>
                        </tr>
                        <tr>
                            <th>Total Price</th>
                            <td>RM {{ locationType === '2' ? (this.employees.length * vaccinePrice) + 200 : this.employees.length * vaccinePrice }}</td>
                        </tr>
                    </table>

                    <!-- Location info -->
                    <table class="table table-bordered table-sm">
                        <colgroup>
                            <col width="250">
                            <col>
                        </colgroup>
                        <tr>
                            <th colspan="2" class="text-uppercase">Location info</th>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <td>{{ locationType === '1' ? 'Clinic' :  'Onsite'}}</td>
                        </tr>
                        <tr v-if="locationType === '1'">
                            <th>Region</th>
                            <td>{{ regionName }}</td>
                        </tr>
                        <template v-else>
                            <tr>
                                <th>Person in Charge</th>
                                <td>{{ picName }}</td>
                            </tr>
                            <tr>
                                <th>Person in Charge Phone</th>
                                <td>{{ picPhone }}</td>
                            </tr>
                            <tr>
                                <th>Prefered Date 1</th>
                                <td>{{ preferedDate1 }}</td>
                            </tr>
                            <tr>
                                <th>Prefered Date 2</th>
                                <td>{{ preferedDate2 }}</td>
                            </tr>
                            <tr>
                                <th>Address</th>
                                <td>{{ `${( address1 + ', ' + address2)}, ${city}, ${postcode} ${state}` }}</td>
                            </tr>
                        </template>
                    </table>

                    <!-- Back Button -->
                    <button
                        @click="previousStep"
                        class="btn btn-secondary"
                    >
                        Previous
                    </button>

                    <!-- Next Button -->
                    <button
                        @click="showConfirmationBeforeSubmit"
                        class="btn btn-primary btn-primary-insv ml-2"
                    >
                        Submit
                    </button>
                </div>
        </div>
    </div>

    <popup-modal ref="popUpAddEmployee" title="Add Employee" :hasCloseButton="true" sizeClass="modal-xl">
        <template slot="content">
            <p><b>Please select employee type.</b></p>
            <div class="mb-3">
                <div class="form-check form-check-inline">
                    <input class="form-check-input " type="radio" name="registeredEmployee" id="registeredEmployee" value="1" v-model="employeeType">
                    <label class="form-check-label" for="registeredEmployee">
                        <b class="text-danger">Registered Employee</b>
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="unregisteredEmployee" id="unregisteredEmployee" value="2" v-model="employeeType">
                    <label class="form-check-label" for="unregisteredEmployee">
                        <b class="text-danger">Unregistered Employee</b>
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="bulkUpload" id="bulkUpload" value="3" v-model="employeeType">
                    <label class="form-check-label" for="bulkUpload">
                        <b class="text-danger">Bulk Upload</b>
                    </label>
                </div>
                <hr>
            </div>

            <template v-if="employeeType === '1'">
                <div class="row mb-3">
                    <div class="col-lg-3 col-12">
                        <label class="mr-2 font-weight-bold">Full Name:</label>
                        <input type="text" name="filterName" data-vv-as="filter full name" data-vv-validate-on="blur"
                            v-model="filterName"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('filterName')
                            }">
                        <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                            {{ validationErrors.first('filterName') }}
                        </div>
                    </div>
                    <div class="col-lg-3 col-12">
                        <label class="mr-2 font-weight-bold">Identity Type:</label>
                        <select name="filterIdentityType" data-vv-validate-on="blur" data-vv-as="identification type"
                            v-validate="identificationTypeValidation" v-model="filterIdentityType" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('filterIdentityType')
                        }">
                            <option value="0">Please Select</option>
                            <option v-for="(identificationType, index) in identificationTypes" :key="index"
                                :value="identificationType.value">
                                {{identificationType.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('filterIdentityType')" class="invalid-feedback">
                            {{ validationErrors.first('filterIdentityType') }}
                        </div>
                    </div>
                    <div class="col-lg-3 col-12">
                        <label class="mr-2 font-weight-bold">Identity Number:</label>
                        <input type="text" name="filterIdentityNumber" data-vv-as="filter NRIC" data-vv-validate-on="blur"
                            v-mask="filterIdentityType === 1 ? '######-##-####' : null" v-model="filterIdentityNumber"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('filterIdentityNumber')
                            }">
                        <div v-show="validationErrors.has('filterIdentityNumber')" class="invalid-feedback">
                            {{ validationErrors.first('filterIdentityNumber') }}
                        </div>
                    </div>
                    <div class="col-lg-3 col-12 d-flex align-items-end">
                        <button @click="getEmployees" class="btn btn-primary">Search</button>
                    </div>
                </div>

                <div class="table-responsive">
                    <div ref="tableSection">
                        <table ref="listTable" class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Employee Name</th>
                                    <th scope="col">NRIC</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-show="employeeList.length === 0">
                                    <td :colspan="columnsCount" class="text-center font-italic">
                                        {{isTableLoading ? "Loading Data": "No Data"}}
                                    </td>
                                </tr>
                                <tr v-for="(employee, index) in employeeList" :key="index">
                                    <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                                    <td>{{employee.name}}</td>
                                    <td>{{employee.nric}}</td>
                                    <td>
                                        <button class="btn btn-primary" :disabled="checkIfSelected(employee.userId)" @click="selectEmployee(employee)">Select</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <pagination v-model="pagination.currentPage"
                        :totalPages="pagination.totalPages"
                        :scrollPosition="pagination.scrollPosition">
                    </pagination>
                </div>
            </template>

            <template v-else-if="employeeType === '2'">
                <p><b>Please enter unregistered employee details.</b></p>
                <form ref="unregisteredEmployeeForm" data-vv-scope="unregisteredEmployee">
                    <div class="row">
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Name</label>
                            <input type="text" name="name" data-vv-as="name" data-vv-validate-on="blur"
                                v-model="unregisteredFields.name" v-validate="'required'"
                                placeholder="Name"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.name')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.name')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.name') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Phone</label>
                            <input type="text" name="phone" data-vv-as="phone" data-vv-validate-on="blur"
                                v-model="unregisteredFields.phone" v-validate="'required'"
                                placeholder="E.g. 0123456789"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.phone')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.phone')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.phone') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Email</label>
                            <input type="text" name="email" data-vv-as="email" data-vv-validate-on="blur"
                                v-model="unregisteredFields.email" v-validate="'required'"
                                placeholder="Email"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.email')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.email')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.email') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Identity Card Number / Passport Number / Others </label>
                            <input type="text" name="identityCardNumber" data-vv-as="identity card number" data-vv-validate-on="blur"
                                v-model="unregisteredFields.identityCardNumber" v-validate="'required'"
                                placeholder="Identity Card Number"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.identityCardNumber')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.identityCardNumber')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.identityCardNumber') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Date of Birth</label>
                            <input type="text" name="dob" data-vv-as="birth date" data-vv-validate-on="blur"
                                    v-model="unregisteredFields.dob"
                                    v-mask="'##/##/####'"
                                    v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                                    :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.dob')
                                }" />
                            <div v-show="validationErrors.has('unregisteredEmployee.dob')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.dob') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Gender</label>
                            <select name="gender" data-vv-validate-on="blur" v-model="unregisteredFields.gender" v-validate="genderValidation"
                                :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('unregisteredEmployee.gender')
                            }">
                                <option value="0">Please Select</option>
                                <option v-for="(gender, index) in genders" :key="index" :value="gender.value">
                                    {{gender.text}}
                                </option>
                            </select>
                            <div v-show="validationErrors.has('unregisteredEmployee.gender')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.gender') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">Nationality</label>
                            <input type="text" name="nationality" data-vv-as="nationality" data-vv-validate-on="blur"
                                v-model="unregisteredFields.nationality" v-validate="'required'"
                                placeholder="E.g. Malaysian"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.nationality')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.nationality')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.nationality') }}
                            </div>
                        </div>
                        <div class="col-lg-6 col-12 mb-2">
                            <label class="mr-2">MySejahtera ID</label>
                            <input type="text" name="mySejahteraId" data-vv-as="mySejahteraId" data-vv-validate-on="blur"
                                v-model="unregisteredFields.mySejahteraId" v-validate="'required'"
                                placeholder="E.g. 0123456789"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('unregisteredEmployee.mySejahteraId')
                                }">
                            <div v-show="validationErrors.has('unregisteredEmployee.mySejahteraId')" class="invalid-feedback">
                                {{ validationErrors.first('unregisteredEmployee.mySejahteraId') }}
                            </div>
                        </div>
                    </div>
                </form>
            </template>

            <template v-else>
                <div class="mb-3">
                    <h5>Instructions</h5>
                    <ol>
                        <li>
                            Download the sample file template here.
                            <div><a href="/static/samples/sample_bulk_add_vaccination_employee.xlsx" target="_blank" class="mt-1 mb-2 btn btn-primary btn-primary-insv">Download Template File</a></div>
                        </li>
                        <li>
                            Open the downloaded file and fill up the file with the required fields. Example as below.
                            <br>
                            <span class="text-danger font-small">*For registered employee, Identity Number MUST be exactly the same as when employee first registered.</span>
                            <div class="mt-1 mb-2">
                                <img src="/static/samples/sample_bulk_add_vaccination_employee.png" class="img img-fluid">
                            </div>
                        </li>

                        <li>Select and upload the file here.</li>
                        <li>Review the user list and proceed!</li>
                    </ol>
                </div>
            </template>
        </template>

        <template slot="footer">
            <template v-if="employeeType === '1'">
                <p class="w-100 float-left"><b>Please enter additonal employee details.</b></p>
                <div class="row w-100">
                    <div class="col-lg-6 col-12 mb-2">
                        <label for="">Name</label>
                        <input class="form-control" type="text" disabled v-model="registeredFields.name">
                    </div>
                    <div class="col-lg-6 col-12 mb-2">
                        <label for="">Identity Card Number</label>
                        <input class="form-control" type="text" disabled  v-model="registeredFields.identityCardNumber">
                    </div>
                    <div class="col-lg-6 col-12 mb-2">
                        <label class="mr-2">Nationality</label>
                        <input type="text" ref="nationality" name="nationality" data-vv-as="nationality" data-vv-validate-on="blur"
                            v-model="registeredFields.nationality" v-validate="'required'"
                            placeholder="E.g. Malaysian"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('nationality')
                            }">
                        <div v-show="validationErrors.has('nationality')" class="invalid-feedback">
                            {{ validationErrors.first('nationality') }}
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 mb-2">
                        <label class="mr-2">MySejahtera ID</label>
                        <input type="text" name="mySejahteraId" data-vv-as="mySejahteraId" data-vv-validate-on="blur"
                            v-model="registeredFields.mySejahteraId" v-validate="'required'"
                            placeholder="E.g. 0123456789"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('mySejahteraId')
                            }">
                        <div v-show="validationErrors.has('mySejahteraId')" class="invalid-feedback">
                            {{ validationErrors.first('mySejahteraId') }}
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="text-right">
                            <button class="btn btn-primary btn-primary-insv mr-2" @click="addRegisteredEmployee">Add</button>
                            <button class="btn btn-secondary" @click="()=>{ $refs.popUpAddEmployee.hide(); }">Done</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="employeeType === '2'">
                <div class="text-right">
                    <button class="btn btn-primary btn-primary-insv mr-2" @click="addUnregisteredEmployee">Add</button>
                    <button class="btn btn-secondary" @click="()=>{ $refs.popUpAddEmployee.hide(); }">Done</button>
                </div>
            </template>
            <template v-else>
                <div class="card w-100">
                    <div class="card-header">Upload User List</div>
                    <div class="card-body">
                        <form id="uploadForm" @submit.prevent="validateUploadForm">
                            <div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-xl-2 col-form-label">Employee List File</label>
                                    <div class="col-sm-9 col-xl-10">
                                        <input id="uploadFileInput" type="file" v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" data-vv-as="user list file" name="userList"
                                            :class="{'is-invalid':  validationErrors.has('userList')}">
                                        <div v-show="validationErrors.has('userList')" class="invalid-feedback">
                                            {{ validationErrors.first('userList') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                        <p v-show="isSubmitMessageShown" :class="{
                                            'text-danger': isSubmitMessageError,
                                            'mb-3': true
                                        }">
                                            {{submitMessage}}
                                        </p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                        <button :disabled="isUploading" class="btn btn-primary btn-primary-insv">Upload Employee List File</button>
                                        <button :disabled="isUploading" class="btn btn-secondary ml-2" @click="()=>{ $refs.popUpAddEmployee.hide(); }">Done</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </template>
    </popup-modal>

    <popup-modal ref="popUpBulkAddCompleted" title="Bulk Upload Complete" :hasCloseButton="true">
        <template slot="content">
            <p>{{this.submitMessage}}</p>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-secondary" @click="()=>{ $refs.popUpBulkAddCompleted.hide(); this.submitMessage = ''; }">Close</button>
        </template>
    </popup-modal>

    <popup-modal ref="popupBookingConfirmation" title="Important Notice" :hasCloseButton="true" sizeClass="modal-xl">
        <template slot="content">
            <p>
                Note : The following terms and conditions will be applied. You are advised to read and accept them before making your booking.
            </p>
            <ol>
                <li>
                    No refund nor replacement for any paid vaccination, if a recipient fails to attend the given appointment.
                    <p class="mt-2">
                        Reason : Sinovac vaccine is sold in a vial packaging, whereby each vial is allocated for 2 persons’ vaccination about same time. Unused vaccine must be discarded once a vial is opened.
                    </p>
                </li>
                <li>
                    We will assign a vaccination’s appointment to a clinic locating nearest to your region. SMS will be sent out to recipients’ handphone numbers for confirming their actual locations and times of vaccinations, within a week after payments are made.
                    <p class="mt-2">
                        Reason : Depending on the current stocks of vaccines at respective clinics during your booking.
                    </p>
                </li>
                <li>
                    If onsite vaccination is required (minimum 10 persons or more), at same place & same time within Klang Valley, doctor will charge an extra travel allowance amounted RM200 for this service.
                </li>
            </ol>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="dismissAndContinueToPayment">
                Proceed to Make Payment
            </button>
            <button type="button" class="btn btn-secondary" @click="()=>{ $refs.popupBookingConfirmation.hide(); }">Discard</button>
        </template>
    </popup-modal>

    <div style="display: none;">
        <form ref="insvPayment" method="post" :action="paymentSubmitPath">
            <input type="text" name="UseWallet" value="false" />
            <input type="text" name="PaymentWalletAmount"  value="0" />
            <input type="text" name="PaymentSummaryId"  v-model="paymentSummaryId" />
            <input type="text" name="PaymentRemarks" value="Vaccination" />
            <input name="Token" v-model="token" type="hidden">
        </form>
    </div>

</div>
</template>

<script>
import { convertDateToDDMMYYYY, convertDateToIso8601 } from '@/utilities';
import { apiPath } from '@/config';
import Stepper from 'bs-stepper';
import popupModal from '@/components/popup-modal';
import pagination from '@/components/pagination';
import identificationTypes from '@/config/identificationTypes';
import { VueMaskDirective } from 'v-mask';
import _ from 'lodash';
import genders from '@/config/genders';
import Cookies from 'js-cookie';

export default {
    'name': 'CompanyVaccinationBooking',
    'directives': {
        'mask': VueMaskDirective
    },
    'components': {
        popupModal,
        pagination
    },
    data () {
        return {
            'vaccinePrice': 360, // Hardcode for now
            'columnsCount': 1,
            'isTableLoading': true,
            'paymentSummaryId': null,
            'filterName': '',
            'filterIdentityType': 0,
            'filterIdentityNumber': '',
            'filterTier': '',
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 5,
                'scrollPosition': 0
            },
            'employeeList': [],
            'registeredFields': {
                'userId': null,
                'name': null,
                'phone': null,
                'email': null,
                'identityCardNumber': null,
                'dob': null,
                'gender': null,
                'nationality': null,
                'mySejahteraId': null
            },
            'unregisteredFields': {
                'name': null,
                'phone': null,
                'email': null,
                'identityCardNumber': null,
                'dob': null,
                'gender': null,
                'nationality': null,
                'mySejahteraId': null
            },
            'address1': null,
            'address2': null,
            'city': null,
            'state': null,
            'postcode': null,
            'picName': null,
            'picPhone': null,
            'preferedDate1': null,
            'preferedDate2': null,
            'employeeType': '1',
            'locationType': '1',
            'employees': [],
            'regions': [],
            'regionId': 1,
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'isUploading': false,
            genders,
            identificationTypes,
            convertDateToDDMMYYYY
        };
    },
    'computed': {
        paymentSubmitPath () {
            return `${apiPath}MakePayment/Pay`;
        },
        currentPage () {
            return this.pagination.currentPage;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        },
        genderValidation () {
            let minGenderValue = this.genders[0].value;
            let maxGenderValue = this.genders[this.genders.length - 1].value;

            return `required|between:${minGenderValue},${maxGenderValue}`;
        },
        regionName () {
            const selectedRegion = this.regions.find(r => r.id === this.regionId);

            if (selectedRegion) {
                return selectedRegion.name;
            }

            return '-';
        },
        token () {
            return Cookies.get('t');
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getEmployees();
            });
        }
    },
    'methods': {
        async nextStep (step) {
            if (step === 1) {
                if (this.employees.length <= 0) {
                    return alert('Employee List cannot be empty!');
                }

                if (this.employees.length < 10) {
                    this.locationType = '1';
                }
            } else if (step === 2) {
                if (this.locationType === '2') {
                    let result = await this.$validator.validateAll('onsiteForm');
                    if (!result) {
                        return;
                    }
                }
            }
            this.stepper.next();
        },
        previousStep () {
            this.stepper.previous();
        },
        showConfirmationBeforeSubmit () {
            this.$refs.popupBookingConfirmation.show();
        },
        dismissAndContinueToPayment () {
            this.$refs.popupBookingConfirmation.hide(() => {
                this.submit();
            });
        },
        submit () {
            // Data massaging
            let payload = {
                'lt': this.locationType === '1' ? 0 : 1,
                'vi': 1, // Hardcode for now
                'r': this.regionId,
                'a1': this.address1,
                'a2': this.address2,
                'ac': this.city,
                'as': this.state,
                'ap': this.postcode,
                'pd1': this.preferedDate1 ? convertDateToIso8601(this.preferedDate1) : null,
                'pd2': this.preferedDate2 ? convertDateToIso8601(this.preferedDate2) : null,
                'picn': this.picName,
                'picp': this.picPhone,
                're': [],
                'ue': []
            };

            for (let employee of this.employees) {
                if (employee.userId) {
                    payload.re.push({
                        'ui': employee.userId,
                        'na': employee.nationality,
                        'msi': employee.mySejahteraId
                    });
                } else {
                    payload.ue.push({
                        'n': employee.name,
                        'p': employee.phone,
                        'e': employee.email,
                        'icn': employee.identityCardNumber,
                        'd': convertDateToIso8601(convertDateToDDMMYYYY(employee.dob)),
                        'g': employee.gender,
                        'na': employee.nationality,
                        'msi': employee.mySejahteraId
                    });
                }
            }

            this.axios.post('Vaccination/CompanyBooking', payload).then((response) => {
                this.paymentSummaryId = response.data.data.paymentSummaryId;
                this.$nextTick(() => {
                    this.$refs.insvPayment.submit();
                });
            });
        },
        getEmployees () {
            this.axios.post('employeeTier/GetEmployeeList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'fn': this.filterName,
                'it': this.filterIdentityType,
                'in': this.filterIdentityNumber,
                'ti': this.filterTier
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.employeeList = list.map((employee) => ({
                    'userId': employee.ui,
                    'name': employee.fn ? employee.fn : null,
                    'nric': employee.in ? employee.in : null,
                    'phone': employee.pn ? employee.pn : null,
                    'email': employee.e ? employee.e : null,
                    'dob': employee.dob ? employee.dob : null,
                    'gender': employee.g ? employee.g : null,
                    'tierName': employee.tn,
                    'employeeTierId': employee.eti,
                    'spouseCount': employee.sc,
                    'dependentCount': employee.dc
                }));
            });
        },
        selectEmployee (employee) {
            if (!employee.name || !employee.nric || !employee.phone || !employee.email || !employee.dob || !employee.gender) {
                alert('User profile incomplete! This employee has some incomplete information, please ask employee to update their profile!');
                return 0;
            }

            this.registeredFields.userId = employee.userId;
            this.registeredFields.name = employee.name;
            this.registeredFields.phone = employee.phone;
            this.registeredFields.email = employee.email;
            this.registeredFields.identityCardNumber = employee.nric;
            this.registeredFields.dob = employee.dob;
            this.registeredFields.gender = employee.gender;

            this.$refs.nationality.focus();
        },
        async addRegisteredEmployee () {
            if (!this.registeredFields.name || !this.registeredFields.phone || !this.registeredFields.email || !this.registeredFields.identityCardNumber || !this.registeredFields.dob || !this.registeredFields.gender) {
                alert('Please select an employee first!');
                return 0;
            }

            let mySejahteraIdResult = await this.$validator.validate('mySejahteraId');
            let nationalityResult = await this.$validator.validate('nationality');

            if (mySejahteraIdResult && nationalityResult) {
                this.employees.push(_.cloneDeep(this.registeredFields));

                this.registeredFields.userId = null;
                this.registeredFields.name = null;
                this.registeredFields.phone = null;
                this.registeredFields.email = null;
                this.registeredFields.identityCardNumber = null;
                this.registeredFields.dob = null;
                this.registeredFields.gender = null;
                this.registeredFields.nationality = null;
                this.registeredFields.mySejahteraId = null;
            }
        },
        async addUnregisteredEmployee () {
            let result = await this.$validator.validateAll('unregisteredEmployee');

            if (result) {
                let unregistered = _.cloneDeep(this.unregisteredFields);
                unregistered.dob = convertDateToIso8601(unregistered.dob);
                this.employees.push(unregistered);

                this.unregisteredFields.name = null;
                this.unregisteredFields.phone = null;
                this.unregisteredFields.email = null;
                this.unregisteredFields.identityCardNumber = null;
                this.unregisteredFields.dob = null;
                this.unregisteredFields.gender = null;
                this.unregisteredFields.nationality = null;
                this.unregisteredFields.mySejahteraId = null;
            }
        },
        checkIfSelected (userId) {
            let employee = this.employees.find((e) => e.userId === userId);
            if (employee != null) {
                return true;
            }
            return false;
        },
        removeEmployee (index) {
            this.employees.splice(index, 1);
        },
        getRegions () {
            this.axios.get('Region/GetAll').then((response) => {
                this.regions = response.data.data.regions.map((region) => {
                    return {
                        'id': region.i,
                        'name': region.n
                    };
                });
            });
        },
        validateUploadForm () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            this.$validator.validate('userList').then((isValidate) => {
                if (isValidate) {
                    let bulkFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    formData.append('BulkInviteFile', bulkFile.files[0]);
                    this.submitMessage = 'Uploading and processing bulk invite file.';
                    this.isUploading = true;
                    this.axios.post('Vaccination/BulkVerify', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({ data }) => {
                        let result = data.data;
                        if (result.s) {
                            for (let employee of result.ve) {
                                this.employees.push({
                                    'userId': employee.ui,
                                    'name': employee.n,
                                    'phone': employee.p,
                                    'email': employee.e,
                                    'identityCardNumber': employee.icn,
                                    'dob': employee.dob,
                                    'gender': employee.g,
                                    'nationality': employee.na,
                                    'mySejahteraId': employee.msi
                                });
                            }

                            let form = document.querySelector('#uploadForm');
                            form.reset();
                            this.isUploading = false;
                            this.$refs.popUpAddEmployee.hide();
                            this.$nextTick(() => {
                                this.submitMessage = `Total ${result.rec} registered employee and ${result.uec} unregistered employee added to the list. Please review the list.`;
                                this.$refs.popUpBulkAddCompleted.show();
                            });
                        } else {
                            this.isUploading = false;
                            let form = document.querySelector('#uploadForm');
                            form.reset();
                            this.isSubmitMessageError = true;
                            this.submitMessage = result.e;
                        }
                    });
                } else {
                    let form = document.querySelector('#uploadForm');
                    form.reset();
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s).';
                }
            });
        }
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getRegions();
        this.getEmployees();
        // Setup Stepper
        this.stepper = new Stepper(document.querySelector('.bs-stepper'));

        // custom error message for sms
        const validateDict = {
            'custom': {
                'phone': {
                    'required': 'The phone field is required, for receiving SMS about the date of vaccination.'
                }
            }
        };

        this.$validator.localize('en', validateDict);
    }
};
</script>

<style>

</style>
